export default "__VITE_ASSET__T$ODuQKa__"